import { render } from "./OfflinePage.vue?vue&type=template&id=9774e8e2"
import script from "./OfflinePage.vue?vue&type=script&lang=js"
export * from "./OfflinePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__